export default __webpack_public_path__ + "static/media/visa.84075d58.svg";